import { InvoiceBillingStage } from '@features/invoices/enums/invoiceBillingStage'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { InvoiceEventType } from '@features/invoices/enums/invoiceEventType'
import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'

import {
  creditNoteStatusToTranslationKey,
  invoiceBillingStageStatusToTranslationKey,
  invoiceStatusToTranslationKey,
} from '../constants/invoiceStatusToTranslationKey'

export const getTimelineStatusTranslationKey = (
  event: InvoiceEventType,
  documentType?: InvoiceDocumentType,
  invoiceBillingStage?: InvoiceBillingStage,
): string => {
  const isCreditNote = isDocumentTypeCreditNote(documentType)

  if (isCreditNote && !!creditNoteStatusToTranslationKey[event]) {
    return creditNoteStatusToTranslationKey[event] ?? event
  }

  if (invoiceBillingStage) {
    return (
      invoiceBillingStageStatusToTranslationKey[invoiceBillingStage]?.[event] ??
      invoiceStatusToTranslationKey[event] ??
      event
    )
  }

  return invoiceStatusToTranslationKey[event] ?? event
}
